/* ============================================================================
   Ullavi local helpers shim — restores the GLOBAL helper functions that lived
   in the removed remote Shrine main.js bundle (js.shrinetheme.com/js/v2/main.js).
   NO external calls, self-contained, idempotent (never clobbers a real def).

   The cleaned theme kept media-gallery.js / secondary.js / etc., but those call
   bare globals (debounce, pauseAllMedia, playActiveMedia, trapFocus, fetchConfig,
   ...) that main.js used to define. With main.js gone they were undefined, so:
     - media-gallery.js threw "debounce is not defined" in its constructor, and
       setActiveMedia threw "pauseAllMedia is not a function" on thumbnail click,
       so clicking a gallery thumbnail did NOT switch the main product image.
     - modal/drawer focus-trapping, media pause/play, and fetch config were dead.

   MUST load before secondary.js / media-gallery.js — it is included (also defer)
   immediately before secondary.js in layout/theme.liquid.
   ============================================================================ */
(function () {
  var W = window;
  function def(name, fn) { if (typeof W[name] === 'undefined') W[name] = fn; }

  def('debounce', function (fn, wait) {
    var t;
    return function () { var c = this, a = arguments; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait || 0); };
  });
  def('throttle', function (fn, delay) {
    var last = 0;
    return function () { var n = Date.now(); if (n - last < (delay || 0)) return; last = n; return fn.apply(this, arguments); };
  });

  /* pub/sub (Dawn pubsub.js) */
  if (typeof W.PUB_SUB_EVENTS === 'undefined') {
    W.PUB_SUB_EVENTS = { cartUpdate: 'cart-update', quantityUpdate: 'quantity-update', variantChange: 'variant-change', cartError: 'cart-error', optionValueSelectionChange: 'option-value-selection-change' };
  }
  if (typeof W.subscribe === 'undefined') {
    var _subs = {};
    W.subscribe = function (e, cb) { (_subs[e] = _subs[e] || []).push(cb); return function () { _subs[e] = (_subs[e] || []).filter(function (c) { return c !== cb; }); }; };
    W.publish = function (e, d) { (_subs[e] || []).forEach(function (cb) { cb(d); }); };
  }

  /* focus / a11y (Dawn global.js) */
  def('getFocusableElements', function (container) {
    return Array.from(container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    ));
  });
  var trapHandlers = {};
  def('trapFocus', function (container, elementToFocus) {
    elementToFocus = elementToFocus || container;
    var els = W.getFocusableElements(container), first = els[0], last = els[els.length - 1];
    W.removeTrapFocus();
    trapHandlers.focusin = function (e) { if (e.target !== container && e.target !== last && e.target !== first) return; document.addEventListener('keydown', trapHandlers.keydown); };
    trapHandlers.focusout = function () { document.removeEventListener('keydown', trapHandlers.keydown); };
    trapHandlers.keydown = function (e) {
      if (e.code && e.code.toUpperCase() !== 'TAB') return;
      if (e.target === last && !e.shiftKey) { e.preventDefault(); first && first.focus(); }
      if ((e.target === container || e.target === first) && e.shiftKey) { e.preventDefault(); last && last.focus(); }
    };
    document.addEventListener('focusout', trapHandlers.focusout);
    document.addEventListener('focusin', trapHandlers.focusin);
    if (elementToFocus && elementToFocus.focus) elementToFocus.focus();
  });
  def('removeTrapFocus', function (elementToFocus) {
    document.removeEventListener('focusin', trapHandlers.focusin);
    document.removeEventListener('focusout', trapHandlers.focusout);
    document.removeEventListener('keydown', trapHandlers.keydown);
    if (elementToFocus && elementToFocus.focus) elementToFocus.focus();
  });
  def('onKeyUpEscape', function (e) {
    if (e.code && e.code.toUpperCase() !== 'ESCAPE') return;
    var d = e.target.closest('details[open]'); if (!d) return;
    var s = d.querySelector('summary'); d.removeAttribute('open'); if (s) { s.setAttribute('aria-expanded', false); s.focus(); }
  });

  /* media (Dawn global.js) */
  def('pauseAllMedia', function () {
    document.querySelectorAll('.js-youtube').forEach(function (v) { try { v.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'); } catch (e) {} });
    document.querySelectorAll('.js-vimeo').forEach(function (v) { try { v.contentWindow.postMessage('{"method":"pause"}', '*'); } catch (e) {} });
    document.querySelectorAll('model-viewer').forEach(function (m) { try { m.pause(); } catch (e) {} });
  });
  def('playActiveMedia', function (activeItem) {
    W.pauseAllMedia();
    if (!activeItem || !activeItem.querySelector) return;
    var model = activeItem.querySelector('model-viewer'); if (model && model.play) { try { model.play(); } catch (e) {} }
    var dm = activeItem.querySelector('deferred-media'); if (dm && dm.loadContent) { try { dm.loadContent(false); } catch (e) {} }
  });

  /* fetch config (Dawn global.js) */
  def('fetchConfig', function (type) {
    type = type || 'json';
    return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/' + type } };
  });
})();
